window.toggleCalendarEvent = function(node) {
    
    let parentNode = node.closest('.js-calendar-event');
    let contentNode = parentNode.querySelector('.js-calendar-event__content');
    let button = parentNode.querySelector('.js-calendar-event__button');

    if(contentNode.classList.contains('hidden')) {
        contentNode.classList.add('grid');
        contentNode.classList.remove('hidden');
        button.classList.add('js-calendar-event__button--active');
    }
    else {
        contentNode.classList.remove('grid');
        contentNode.classList.add('hidden');
        button.classList.remove('js-calendar-event__button--active');
    }
}